
import { Flex, Box } from "@chakra-ui/react"
import Icon from "components/UI/atoms/Icon"
import Button from "components/UI/atoms/Button"
import MainLayout from "components/templates/MainLayout"
import CompanyBranches from "components/shared/CompanyBranches"
import Searchbar from "components/UI/molecules/Searchbar"
import ReservationsToolbar from "./ReservationsToolbar"
import ReservationsTable from "./ReservationsTable"
import { useReservationsContext } from "providers/ReservationsProvider/ReservationsProvider"
import { useUI } from "providers/UIProvider"
import { IRoles } from "types/shared"
import { useAppContext } from "providers/AppProvider/AppProvider"


const ReservationsTemplate = () => {
  const { searchValue, handleSearchChange } = useReservationsContext()
  const { toggleModal, T } = useUI();
  const { userRole } = useAppContext();

  const isQappUser = userRole && [IRoles.QAPP_ADMIN, IRoles.QAPP_MANAGER].includes(userRole);

  return (
    <MainLayout navigation>
      <Flex flexDirection={"column"} paddingLeft={window.innerWidth <= 1170 ? "" : "0px"}>
        <Flex
          width={"100%"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <CompanyBranches />
          <Flex>
            {userRole !== IRoles.CASHIER &&
              <Button
                onClick={() => isQappUser ? toggleModal("webReservationsTimesModal", true) : toggleModal("webReservationsModal", true)}
                text={T("booking.new.reservation")}
                style={{
                  backgroundColor: "#08BA36",
                  color: "#FFFFFF",
                  width: "14.5rem",
                  height: "3.938rem",
                  fontSize: "1.125rem",
                  boxShadow: "0px 15px 30px #046CEC1A",
                  marginRight: "1.5rem"
                }}
                leftIcon={
                  <Icon
                    name="add_circle"
                    iconStyles={{ width: "34px", height: "34px" }}
                  />
                }
              />
            }
            <Searchbar
              value={searchValue}
              onChange={(e) => handleSearchChange(e.currentTarget.value)}
            />
          </Flex>

        </Flex>
        <Box mt={"20px"}>
          <ReservationsToolbar />
          <ReservationsTable />
        </Box>
      </Flex>
    </MainLayout>
  )
}

export default ReservationsTemplate
